var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin-add"}},[_c('bo-add-user',{attrs:{"title":"Nouvel utilisateur","subtitle":"Back Office","action":"add","groups":['user'],"userCss":"col-xs-10 col-sm-8 col-md-4","routePrefix":_vm.routePrefix,"storePrefix":"bouser"},on:{"end-edit-user":function($event){return _vm.goToList($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }